import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RefundPolicyService } from 'src/app/features/restaurants/services/Cancellation.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import Swal from 'sweetalert2';

export interface DialogData {
  reservationNumber: number,
  restaurantId: number
}

@Component({
  selector: 'app-exception-rule-reservation',
  templateUrl: './exception-rule-reservation.component.html'
})
export class ExceptionRuleReservationComponent extends DirtyComponent implements OnInit {

  override formGroup!: FormGroup;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.reservationNumber ? true : false;
  constructor(override dialogRef: MatDialogRef<ExceptionRuleReservationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder,
    translate: TranslateService, private service: RefundPolicyService) {
    super(translate)
  }

  ngOnInit(): void {
    this.buildForm();
    if (this.data.reservationNumber) {
      this.bindDataToUpdate();
    }
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      reservationNumber: [0, [
        Validators.maxLength(10),
        Validators.required,
      ]],
      restaurantId: this.data.restaurantId
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
  override canDeactivate(): boolean {
    return this.formGroup.dirty;
  };
  bindDataToUpdate() {
    this.formGroup.patchValue({
      reservationNumber: this.data.reservationNumber,
      restaurantId: this.data.restaurantId
    });
  }


  saveRecord(openNew: boolean = false) {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        reservationNumber: this.formGroup.controls['reservationNumber'].value,
        restaurantId: this.data.restaurantId
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.reservationNumber = this.formGroup.controls['reservationNumber'].value,
          data.restaurantId = this.data.restaurantId
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.EditReservationNumber(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        if (openNew) {
          this.formGroup.reset();
          this.service.refreshList.next(true);
        } else {
          this.dialogRef.close(true);
        }
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }


}
